import { Scope } from './interface'
import { store } from '../../stateManager';

declare const window: any;
// interface Window {
//   dataLayer: any[];
// }

export const initializeA8FormsTypeDefs = () => {
  const a8FormsDefs = `
        type NewTabDetails = {
          newTabName: string;
          newTabKey: string;
        }

        type AddressComponent = {
          long_name: string;
          short_name: string;
          types: string[];
        }

        interface GeocoderResult {
          address_components: AddressComponent[];
          formatted_address: string;
          partial_match?: boolean;
          place_id: string;
          plus_code?: {
            compound_code?: string;
            global_code: string;
          }
          postcode_localities?: string[];
          types: string[];
        }

        type CurrentLocation = {
          latitude: number,
          longitude: number,
          result: {
            address: string,
            rawResult: {
              results: GeocoderResult[],
              status: string
            }
          }
        }
        type SaveResp={
          status:string,
          error?:any
        }

        interface IShared {
          setVisibility: (visible: boolean) => void;
          setVisibilityCondition: (condition: string) => void;
          setClassList: (condition: string[]) => void;
        }
        interface IComponentV2 extends IAssetMutate {
          asset: (assetInstanceId: string) => IComponentV2
        }

        type Asset = IComponent

        interface IAssetMutate {
          asset: (assetInstanceId: string) => Asset;
          importAsset: (assetId: string, options: { bindPrefix: string, after?: string }) => string;
          deleteAsset: (assetInstaceId: string) => void;
          setLabel: (label: string) => void
          setReadOnly: (readOnly: boolean) => void;
        }

        interface ITabState {
          importAsset: (assetId: string, options: { bindPrefix: string, after?: string }) => string;
          deleteAsset: (assetInstaceId: string) => void;
          setLabel: (label: string) => void
          switch: () => void;
          setReadOnly: (readOnly: boolean) => void;
          setVisibility: (visible:boolean) => void;
        }

        // this interface will be dynamically populated by marketplace
        // core and third-party plugins
        interface IComponent {
         Container: (id: string) => IAssetMutate
         Section: (id: string) => IAssetMutate
        }

        interface ISoloForm {
          save: () => Promise<SaveResp>
          docPreview: () => null
          closeFrame: () => null
          complete: () => null
          goBack: () => null
          getCurrentLocation: () => Promise<CurrentLocation>
          beginTransaction: () => null;
          commitTransaction: () => null;    
          ga: (eventType: string, eventName?: string, metaData?: any) => void
          isReadOnly: () => boolean;
          Tab: (tabKey: string) => IShared;
          reload: () => void;
        }

        interface ISoloFormV2 {
          save: () => Promise<SaveResp>
          docPreview: () => null
          closeFrame: () => null
          submit: () => null
          goBack: () => null
          getCurrentLocation: () => Promise<CurrentLocation>
          beginTransaction: () => null;
          commitTransaction: () => null;    
          ga: (eventType: string, eventName?: string, metaData?: any) => void
          Tab: (tabKey: string) => IShared;
          reload: () => void;
        }
     
        interface IForm {
          createTabClone: (tabKeyToClone: string, appendAfterTabKey: string, newTabDetails: NewTabDetails) => null
          deleteTabClone: (deleteTabKey: string) => null
          getTabsStartingWith: (prefixTabKey: string) => any[]
          toast: (type: "success" | "error" | "warning" | "info", message: string, options?: {
            autoClose: 2000 | 3500 | 5000;
            hideProgressBar: true | false;
          } | undefined) => void
          alert(content: {
            title: string;
            content: string;
            actions: {
              primary: {
                label: string;
                callback: () => void;
              };
              secondary: {
                label: string;
                callback: () => void;
              };
            };
          }): void
          save: () => Promise<SaveResp>
          submit: () => null
          asset: (assetInstanceId: string) => Asset
          clearAssetLogs: (formId: string) => void
          Tab: (tabKey: string) => ITabState;
          Section: (sectionId: string) => IAssetMutate;
          Container: (containerId: string) => IAssetMutate;
          beginTransaction: () => void;
          commitTransaction: () => void;
          getCurrentLocation: () => Promise<CurrentLocation>;
          showLoader: () => void
          hideLoader: () => void
          ga: (eventType: string, eventName?: string, metaData?: any) => void
          reload: () => void
          isReadOnly:()=>boolean;
          tabSwitch: (tabKey: string) => void;
          }

        declare var a8forms: IA8Forms`

  window.a8FormsTypeDefs = a8FormsDefs
}

export default function a8forms(scope: Scope) {
  const state = store.getState()
  const appType = state.apps.selectedApp.type
  var {formVersion } = state?.apps || {}

  return `

        ${(scope === 'inline' || scope === 'functionClient' || scope === "solo") ?
      `
                interface BindParam {
                    key: string, 
                    value: any, 
                    valueInfo?: any, 
                    update?: boolean
                };
                declare var bindParams: any; 
                declare function setBindParams(key:string, value: any, valueInfo?: any, update?: boolean ): void;
                declare function bulkSetBindParams(paramList: BindParam[]): void;
            `
      :
      ''
    }
        ${window.a8FormsTypeDefs}
        ${(appType === "a8solo" || appType === "a8chat") && scope === 'functionClient' ? `declare function gtm(props:{event: string, data?: any}): void;` : ''}
        ${`type IA8Forms = ${
          (appType === 'a8solo' || appType === "a8chat")
            ? 'ISoloForm & IComponentV2'
            : ( appType === "a8flow" && ( formVersion === 'v1' ||  scope === 'functionClient') )
            ? 'IForm & IComponent'
            : 'ISoloFormV2 & IComponentV2'
        }`}
    `
}
